export const Errors = ({ formikfun, name }) => {
    return <>
        <div style={{ height: '10px' }}>
            {formikfun.touched[name] && formikfun.errors[name] ? (
                <div className="error">{formikfun.errors[name]}</div>
            ) : null}
        </div>

    </>
}